import styled from "styled-components";

export const FAQContainer = styled.div`
  width: calc(100vw - 80px);
  max-width: 1600px;
  margin: 0 auto;
  padding: 80px 0px;

  @media (max-width: 768px) {
    padding: 40px 0px;
    width: calc(100vw - 80px);
  }
`;

export const FAQTitle = styled.h2`
  color: var(--Black-black, #000);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;

  /* Bold/title-S-800 */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1360px;
  margin: 0 auto;
`;

export const FAQItem = styled.details`
  background: white;
  padding: 24px 0;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;

  &[open] {
    summary {
      margin-bottom: 20px;
    }

    svg {
      transform: rotate(180deg);
    }
  }

  summary {
    font-size: 20px;
    font-weight: 700;
    list-style: none;
    position: relative;
    padding-right: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    text-indent: -2.5em;
    padding-left: 2.5em;

    &::-webkit-details-marker {
      display: none;
    }

    svg {
      width: 18px;
      height: 18px;
      position: absolute;
      right: 0;
      top: 4px;
      transition: transform 0.3s ease;
    }

    @media (max-width: 768px) {
      font-size: 16px;
      padding-right: 30px;
      text-indent: -1.4em;
      padding-left: 1.4em;
    }

    @media (max-width: 480px) {
      font-size: 14px;
      padding-right: 25px;
      text-indent: -1.2em;
      padding-left: 1.2em;
      line-height: 1.5;
    }
  }
`;

export const FAQAnswer = styled.div`
  color: #606060;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  p {
    margin-bottom: 12px;
  }

  strong {
    color: rgb(1, 1, 1);
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.4;
  }
`;

export const MoreButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 40px auto 0;
  padding: 12px 40px;
  background-color: white;
  border: 1px solid #999;
  border-radius: 4px;
  color: #666;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    transition: transform 0.3s ease;
  }

  &:hover {
    background-color: #f5f5f5;

    svg {
      transform: translateY(2px);
    }
  }
`;
